import { useCallback, useState } from 'react';
import { useIsomorphicLayoutEffect } from 'react-use';

import { useBreakpointsContext } from '@air/provider-media-query';

export * from '~/components/v2/components/private-selection-bar/utils/selectionBarLayoutTier';

/**
 * Measures the selection toolbar row via callback ref — RefObject deps never
 * re-fire useLayoutEffect when .current attaches, so callback ref is required.
 */
export const useSelectionBarLayoutTier = (): {
  isPhone: boolean;
  toolbarWidth: number | null;
  measureRef: (node: HTMLElement | null) => void;
} => {
  const { isAboveSmallScreen } = useBreakpointsContext();
  const isPhone = !isAboveSmallScreen;
  const [element, setElement] = useState<HTMLElement | null>(null);
  const [toolbarWidth, setToolbarWidth] = useState<number | null>(null);

  const measureRef = useCallback((node: HTMLElement | null) => {
    setElement(node);
  }, []);

  useIsomorphicLayoutEffect(() => {
    if (!element) {
      setToolbarWidth(null);
      return;
    }

    const update = () => setToolbarWidth(element.getBoundingClientRect().width);
    update();

    const observer = new ResizeObserver(() => update());
    observer.observe(element);
    return () => observer.disconnect();
  }, [element]);

  return {
    isPhone,
    toolbarWidth,
    measureRef,
  };
};
